<template>
  <div id="app">
    <component :is="layout">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </component>
  </div>
</template>

<script>
const layout_default = 'default'
export default {
  name: 'AppLayout',
  computed: {
    layout () {
      return 'layout-' + (this.$route.meta.layout || layout_default)
    }
  }
}
</script>
